import { TFunction } from 'react-i18next'

import { mapRoute, mapUnloRoute, sogRoutes } from '@dfds-pax/utils'

import { RouteFilter } from '@/app/[locale]/[ferry]/yourbooking/(yourbooking)/(departure-filters)/RouteFilters'
import { SelectedDepartures, SelectedRoutes } from '@/states/selection.interface'

export const SingleTierRoutes = ['SMSH', 'SHSM', 'SHPO', 'POSH', 'SHSP', 'SPSH']
export const CompundRoutes = ['DVCA', 'CADV', 'DVDK', 'DKDV']

export const getCompoundRoute = (legacyRoute: string | null) => {
  if (legacyRoute === 'DVCA') return 'DVDK'
  if (legacyRoute === 'DVDK') return 'DVCA'
  if (legacyRoute === 'CADV') return 'DKDV'
  if (legacyRoute === 'DKDV') return 'CADV'

  // Returns null now to let filters handle both single and compound routes scenario
  return null
}

const getCompoundPortDescr = (
  t: TFunction<'translation'>,
  routeFilters: RouteFilter,
  portCode?: string,
  selectedPortCode?: string
): string => {
  if (portCode === 'DV') return t('GBDVR')
  if (selectedPortCode === 'FRCQF') return t('FRCQF')
  if (selectedPortCode === 'FRDKK') return t('FRDKK')
  if (routeFilters.frcqf && routeFilters.frdkk) return `${t('FRDKK')} & ${t('FRCQF')}`
  if (routeFilters.frcqf && !routeFilters.frdkk) return t('FRCQF')
  if (!routeFilters.frcqf && routeFilters.frdkk) return t('FRDKK')
  return ''
}

export const getDepartureRouteTitle = (
  returnLeg: boolean,
  routeFilters: RouteFilter,
  selectedRoutes: SelectedRoutes,
  selectedDepartures: SelectedDepartures,
  t: TFunction<'translation'>
) => {
  if (SingleTierRoutes.includes(selectedRoutes.outbound.toUpperCase())) {
    const unloCodes = mapRoute(selectedRoutes.outbound)
    return t(`${!returnLeg ? unloCodes.departureUnLoCode : unloCodes.arrivalUnLoCode}`)
  }
  return `${getCompoundPortDescr(
    t,
    routeFilters,
    !returnLeg ? selectedRoutes.outbound.substring(0, 2) : selectedRoutes?.homebound?.substring(0, 2),
    !returnLeg ? selectedDepartures?.departureOut?.departurePortCode : selectedDepartures?.departureHome?.departurePortCode
  )}`
}

export const getArrivalRouteTitle = (
  returnLeg: boolean,
  routeFilters: RouteFilter,
  selectedRoutes: SelectedRoutes,
  selectedDepartures: SelectedDepartures,
  t: TFunction<'translation'>
) => {
  if (returnLeg && selectedRoutes.homebound && SingleTierRoutes.includes(selectedRoutes.homebound.toUpperCase())) {
    const unloCodes = mapRoute(selectedRoutes.homebound)
    return t(`${!returnLeg ? unloCodes.departureUnLoCode : unloCodes.arrivalUnLoCode}`)
  } else if (!returnLeg && SingleTierRoutes.includes(selectedRoutes.outbound.toUpperCase())) {
    const unloCodes = mapRoute(selectedRoutes.outbound)
    return t(`${!returnLeg ? unloCodes.arrivalUnLoCode : unloCodes.departureUnLoCode}`)
  }
  return `${getCompoundPortDescr(
    t,
    routeFilters,
    !returnLeg ? selectedRoutes?.outbound?.substring(2, 4) : selectedRoutes?.homebound?.substring(2, 4),
    !returnLeg ? selectedDepartures?.departureOut?.arrivalPortCode : selectedDepartures?.departureHome?.arrivalPortCode
  )}`
}

//Adding a specific route check for Jersey products since single tier routes are not always jersey routes
const JerseyRoute = ['SMSH', 'SHSM', 'SHPO', 'POSH']
export const isJerseyRoute = (route?: string): boolean => {
  return route ? JerseyRoute.includes(route.toUpperCase()) : false
}

export const isSogRoute = (route?: string): boolean => {
  return route ? sogRoutes.includes(route.toUpperCase()) : false
}

export const isCompoundRoute = (departurePortCode?: string, arrivalPortCode?: string): boolean => {
  const route = mapUnloRoute(`${departurePortCode}-${arrivalPortCode}`)
  return route ? CompundRoutes.includes(route.toUpperCase()) : false
}

export const isCompoundRouteUsingRoute = (routeCode: string): boolean => {
  return CompundRoutes.includes(routeCode.toUpperCase())
}
